/* file description */

import { Api } from '@cui/req';


export const getPicInfo = async (data) => {
  const res = await Api({
    method: 'post',
    url: '/api/gateway/workspaceservice/workspace/business/card/query/code',
    data,
  });
  return res[1] || {};
};

export const getFsToken = async () => {
  const res = await Api({
    method: 'get',
    url: '/api/gateway/boulder-gateway/form_submit/token',
  });
  return res?.[1].data || {};
};

